<template>
  <q-page class="main">
    <common-form ref="form" :action="$route('project.map.update', {project_id: project.id})" is-update>
      <q-card class="page-card">
        <q-card-section class="page-card__main-content">
          <h1 class="heading-2 q-mb-lg">Bewerkt project gebied</h1>
          <base-map width="100%"
                    height="500px"
                    canDraw
                    auto-fit
                    v-model:geometry="geometry" />
          <input type="hidden" name="geometry" :value="geometry" />
        </q-card-section>
        <q-separator />
        <q-card-actions align="right" class="q-pa-md">
          <accent-button label="Opslaan" @click="onMapSubmit()" />
        </q-card-actions>
      </q-card>
      <sticky-top-bar />
    </common-form>
  </q-page>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
      required: false,
    },
  },
  data () {
    return {
      geometry: this.project.json_polygon,
    }
  },
  methods: {
    async onMapSubmit () {
      if (!await this.$confirm(
          {
            title: 'Kaart opslaan',
            messages: [
              'Het aanpassen van de kaart van dit  project zal de koppeling tussen richtlijnen en dit project ' +
              'veranderen. Weet u zeker dat u deze wijziging wilt opslaan?',
            ],
          },
      )) {
        return
      }
      this.$refs.form.$el.submit()
    },
  },
}
</script>
